import {Injectable} from '@angular/core';
import {GraphHelperService} from '../../diagram-render/helpers/graph-helper.service';
import {ShapeSpawnerService} from '../../diagram-render/shapes/shape-spawner.service';
import {EditorRegistryService} from '../../diagram-render/mx-graph/editor/editor-registry.service';
import {DiagramUpdateService} from '../../diagram-data/diagram-update.service';
import {TextCreateCommand} from './text.create.command';
import {TextDeleteCommand} from './text.delete.command';
import {TextChangeStyleCommand} from './text.changestyle.command';
import {DiagramJsonHandlerService} from '../../diagram-data/diagram-json-handler.service';
import {TextChangeCommand} from './text.change.command';

@Injectable()
export class TextCommands {
  private serviceObj: object;

  constructor(
    graphHelperSvc: GraphHelperService,
    shapeSpawnerSvc: ShapeSpawnerService,
    editorRegistrySvc: EditorRegistryService,
    diagramUpdateSvc: DiagramUpdateService,
    jsonHandlerSvc: DiagramJsonHandlerService
  ) {
    this.serviceObj = {
      graphHelperSvc,
      shapeSpawnerSvc,
      editorRegistrySvc,
      diagramUpdateSvc,
      jsonHandlerSvc
    };
  }

  public create(data) {
    return new TextCreateCommand(data).injectServices(this.serviceObj);
  }

  public delete(data) {
    return new TextDeleteCommand(data).injectServices(this.serviceObj);
  }

  public changeStyle(mxKey: number, style: any, customStyle: boolean) {
    return new TextChangeStyleCommand({mxKey, style, customStyle})
      .injectServices(this.serviceObj)
      .prepareData();
  }

  public changeText(data, modifications) {
    return new TextChangeCommand(data, modifications).injectServices(this.serviceObj);
  }
}
